import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconTextComponent } from './iconText.component';
import { PlIconModule } from '@app/icon-library/lib/pl-icon.module';
import { ButtonModule } from '@app/components/button/button.module';

@NgModule({
  imports: [CommonModule, PlIconModule, ButtonModule],
  declarations: [IconTextComponent],
  exports: [IconTextComponent],
})
export class IconTextModule {}
